import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, of, EMPTY, forkJoin } from 'rxjs'
import {
  tap,
  map,
  switchMap,
  take,
  catchError,
  withLatestFrom,
  filter,
  concatMap,
  mergeMap,
} from 'rxjs/operators'
import { createEffect, Actions, ofType } from '@ngrx/effects'
import { Store, select } from '@ngrx/store'
import { get, mergeWith } from 'lodash'

import { getValue } from '@app/shared/utils/feature-utils'
import * as fromStore from '@app/core/store'
import * as fromParameters from '../store/parameters-search-security-portfolio-menu.actions'
import { ActionHandler } from '@app/core/components/actions/action.handler'
import { MessagesService } from '@app/core/services/messages/message.service'
import { FeatureService } from '@services/feature/feature.service'
import { SecurityPortfolioService } from '@services-api/security-portfolio.service'
import { CancelAction } from '../actions/parameters-cancel-search-security-portfolio-menu.action'
import { SelectAction } from '../actions/parameters-select-search-security-portfolio-menu.action'
import { environment } from '@env/environment'
/**
 * The base REST API path
 */
const BASE_PATH = environment.basePathExternal
/**
 * The basic effect of the `search` component that fetches the collection of items and their total number.
 * It also handles the business logic and navigation of the configured actions using the `Button` component.
 *
 * It is not recommended to modify this class.
 */
@Injectable()
export class ParametersSearchSecurityPortfolioMenuEffects {
  constructor(
    private actions$: Actions,
    private actionHandler: ActionHandler,
    private store: Store<fromStore.State>,
    private message: MessagesService,
    private httpClient: HttpClient,
    private featureService: FeatureService,
    private service: SecurityPortfolioService,
  ) { }

  /**
   * NGRX effect that fetches the total number of items
   */
  count$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromParameters.countAction),
        switchMap((payload) => {
          return this.service.count(payload.criteria).pipe(
            map((result) =>
              fromParameters.countSuccessAction({
                ...payload,
                totalItems: result,
              })
            ),
            catchError((error) => {
              this.message.openErrorMessage(error)
              return of(fromParameters.countFailAction({ ...payload, error }))
            })
          )
        })
      ),
    { useEffectsErrorHandler: true }
  )
  /**
   * NGRX effect that fetches the data
   */
  find$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromParameters.searchAction),
        switchMap((payload) => {
          const params = {}
          return this.httpClient
            .get<any>(
              `${BASE_PATH}/securityPortfolioUtils/getEligibleSecurityPortfolioList`,
              { params }
            )
            .pipe(
              switchMap((result) => {
                this.message.showHttpMessages(result)
                return [
                  fromParameters.searchSuccessAction({
                    ...payload,
                    value: result,
                  }),
                  fromParameters.countAction({
                    ...payload,
                    ...payload.vars,
                  }),
                ]
              }),
              catchError((error) => {
                this.message.openErrorMessage(error)
                return of(
                  fromParameters.searchFailAction({ ...payload, error })
                )
              })
            )
        })
      ),
    { useEffectsErrorHandler: true }
  )

  /**
   * Effect that runs the `cancel` action and dispatches a `success` or `echec` action
   */
  // cancelAction$ = createEffect((): any =>
  //   this.actions$.pipe(
  //     ofType(fromParameters.cancelAction),
  //     switchMap((payload) => {
  //       return this.actionHandler.perform(this.cancelAction, payload).pipe(
  //         map((result) =>
  //           fromParameters.cancelSuccessAction({ ...payload, data: result })
  //         ),
  //         catchError((error) =>
  //           of(fromParameters.cancelFailAction({ ...payload }))
  //         )
  //       )
  //     })
  //   )
  // )

  /**
   * Effect that runs the `cancel` success action
   */
  cancelSuccessAction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromParameters.cancelSuccessAction),
      switchMap((payload) => {
        return [
          fromParameters.countAction({ ...payload, ...payload.vars }),
          fromParameters.searchAction({ ...payload, ...payload.vars }),
        ]
      })
    )
  )

  /**
   * Effect that runs the `select` action and dispatches a `success` or `echec` action
   */
  // selectAction$ = createEffect((): any =>
  //   this.actions$.pipe(
  //     ofType(fromParameters.selectAction),
  //     switchMap((payload) => {
  //       return this.actionHandler.perform(this.selectAction, payload).pipe(
  //         map((result) =>
  //           fromParameters.selectSuccessAction({ ...payload, data: result })
  //         ),
  //         catchError((error) =>
  //           of(fromParameters.selectFailAction({ ...payload }))
  //         )
  //       )
  //     })
  //   )
  // )

  /**
   * Effect that runs the `select` success action
   */
  selectSuccessAction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromParameters.selectSuccessAction),
      switchMap((payload) => {
        return [
          fromParameters.countAction({ ...payload, ...payload.vars }),
          fromParameters.searchAction({ ...payload, ...payload.vars }),
        ]
      })
    )
  )
}
